import { hasModule } from './hasModule';
export var shouldDisplayEmployerLogo = function shouldDisplayEmployerLogo(cardStyle, modulesV2) {
  return hasModule('Employer Logo', modulesV2) || cardStyle in {
    'sponsored-job': true,
    'job-of-the-week': true,
    'featured-job': true,
    'featured-employer': true
  };
};